import { HttpClient } from '@wix/http-client';
import { Handler } from '../../types';

export const httpClientWithoutAuthorization = new HttpClient();

export const getHttpClient = (
  getInstance: Handler<string>,
  isSSR: boolean = false,
) => new HttpClient({ getAppToken: getInstance, isSSR });
